import { SplitText } from 'gsap/SplitText';
import gsap from 'gsap';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__BlockTextHighlight extends ScrollItem__BlockDefault {
    _words = [];
    _folds = 3;

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._folds = parseInt(getComputedStyle(__link).getPropertyValue('--folds')) || 3;

        const textEl = GetBy.class('__text', __link)[0];
        if (textEl) {
            this._words = new SplitText(textEl, { type: 'words', wordsClass: 'word' }).words;
        }

        this.onShow = () => { };
        this.onHide = () => { };
        this.onMove = () => {
            const total = this._words.length;
            if (!total) return;

            const totalFolds = this._folds + 2;
            const start = 1 / totalFolds;
            const end = (this._folds + 1) / totalFolds;
            const p = Maths.clamp(Maths.normalize(end, start, this.progress), 0, 1);

            const activeCount = Math.round(p * total);
            this._words.forEach((word, i) => {
                if (i < activeCount) word.classList.add('--active');
                else word.classList.remove('--active');
            });
        };
    }

    resize(__w, __h) {
        super.resize(__w, __h);
    }

    dispose() {
        super.dispose();
    }
}

Scroll._registerClass('BlockTextHighlight', ScrollItem__BlockTextHighlight);

export default ScrollItem__BlockTextHighlight;
